import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import roadMaintenanceListAction from './roadMaintenanceList.action.json' with { type: 'json' }
import { roadMaintenanceObject } from '../roadMaintenanceObject'
import roadMaintenanceImageObject from '../../roadMaintenanceImage/roadMaintenanceImageObject'

export const roadMaintenanceExpression = expression(roadMaintenanceObject.shape)

const roadMaintenanceListDefinition = defineAction({
  ...roadMaintenanceListAction,

  input: z.object({
    filter: roadMaintenanceExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      scheduledDate: 'Data agendada',
      updatedAt: 'Data de atualização',
      status: 'Status',
      code: 'Código',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),

  output: z.object({
    items: z.array(
      roadMaintenanceObject.extend({
        images: z.array(roadMaintenanceImageObject.nullish()).nullish(),
      }),
    ),
    count: z.number(),
  }),
})

export default roadMaintenanceListDefinition
